<template>
  <div class='list_wrapper'>
    <div 
        class='list_wrapper-item' 
        v-for='(i,index) in list' 
        :key='i.id' 
        @click='handleItemClick(i)'
        :class='{active:nowClick===i.id }'
        >
      {{i.name}}
    </div>
  </div>
</template>

<script>
  export default {
    props:{
      list:Array,
      isRest:Boolean
    },
  	data(){
  		return {
        nowClick:1,
  		}
  	},
  	created(){

  	},
  	computed: {
     
  	},
  	methods:{
  		handleItemClick(row) {
        if(this.nowClick === row.id) {
          this.nowClick = "";
           row.isSelect = false;
        }else {
          this.nowClick = row.id;
          row.isSelect = true;
        }
        this.$emit('clickItem',row);
      }
  	},
    watch:{
      isRest:{
        handler(val){
          if(val) {
             this.nowClick = "";
             this.$emit('updateIsRest',false)
          }
        },
        immediate:true
      }
    },
  	mounted() {

  	}
  }
</script>

<style lang="less" scoped>
  .list_wrapper {
    .active {
      color: #268AFF;
    }
    &-item {
      color: #4A4A4A;
      cursor: pointer;
      padding-bottom: 20px;
      font-weight: 600;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/AIImport/selectItem.vue